import {AbstractCommand} from "./abstract.command";
import {CommandName} from "./command-name.enum";

/** The payload the backend reads: just the uid of the board to delete. */
export interface DeleteLinkviewPayload {
    readonly uid: string;
}

/**
 * Deletes a Linkboard page. Its TILES ARE NOT TOUCHED — the backend handler
 * deliberately leaves them where they are (a backend test pins that down), so
 * nothing here may promise the user that deleting a board discards its content.
 *
 * A plain-object payload rather than the entity, like the other Linkview
 * commands — see `delete-linkview-command-to-dto.transformer.ts` for why that
 * requires a dedicated transformer.
 */
export class DeleteLinkviewCommand extends AbstractCommand<DeleteLinkviewPayload> {

    public name = CommandName.DELETE_LINKVIEW;

    public tags: string[] = [`entity`, `delete`, `linkview`];

    constructor(payload: DeleteLinkviewPayload) {
        super('linkview', payload.uid, payload);
    }
}
